import { LanguagesEnum } from '@/api/enums';
import { CourseContent } from '@/client/courses';
import { ContinueOrFinishButton } from '@/components/courses/ContinueOrFinishButton';
import { CourseModuleFrame } from '@/components/courses/CourseModuleFrame';
import { SlideTextImageTemplateViewer } from '@/components/slides/learner/slide-templates/SlideTextImageTemplateViewer';
import React, { useState } from 'react';

type CourseSlidesModuleProps = {
  presentationId?: string;
  courseId?: string;
  language: LanguagesEnum;
  currentModuleIndex: number;
  modules: CourseContent[];
  isContentStarted: boolean;
  rtl?: boolean;
  accessibilityIcon?: React.ReactNode;
  onContinue: () => void;
  onFinish: () => void;
  onPreviousModule: () => void;
  isAuthoringPreview?: boolean;
};

export const CourseSlidesModule: React.FC<CourseSlidesModuleProps> = ({
  presentationId,
  courseId,
  language,
  currentModuleIndex,
  modules,
  isContentStarted,
  rtl,
  accessibilityIcon,
  onContinue,
  onFinish,
  onPreviousModule,
  isAuthoringPreview,
}) => {
  const [hasReachedLastPage, setHasReachedLastPage] = useState<boolean>(false);

  return (
    <CourseModuleFrame>
      <SlideTextImageTemplateViewer
        presentationId={presentationId}
        courseId={courseId}
        attemptLanguage={language}
        isAuthoringPreview={isAuthoringPreview}
        hasNextModule={currentModuleIndex !== modules.length - 1}
        hasPreviousModule={currentModuleIndex > 0}
        accessibilityIcon={accessibilityIcon}
        onPreviousModule={onPreviousModule}
        onLastPageReached={() => setHasReachedLastPage(true)}
        continueOrFinishButton={
          <ContinueOrFinishButton
            currentModule={currentModuleIndex}
            modules={modules}
            isCurrentModuleCompleted={hasReachedLastPage}
            isContentStarted={isContentStarted}
            attemptLanguage={language}
            shouldWrapInStickyContainer={false}
            onContinue={onContinue}
            onFinish={onFinish}
            rtl={rtl}
          />
        }
        rtl={rtl}
      />
    </CourseModuleFrame>
  );
};
